export const Vector = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg width='12' height='13' viewBox='0 0 10 11' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M9.03902 6.61795L5 10.657L0.960984 6.61795L3.99025 6.61795L3.99025 0.353016H6.00975L6.00975 6.61795L9.03902 6.61795Z'
      fill='#414C5B'
      transform={props.transform}
    />
  </svg>
);
